module.exports = __webpack_public_path__ + "be482861bbfc37a2bdb9982b916cbe61.pdf";